import { NgModule } from '@angular/core';
import { LawVuGdriveSyncComponent } from './lawvu-gdrive-sync.component';

@NgModule({
  declarations: [LawVuGdriveSyncComponent],
  imports: [
  ],
  exports: [LawVuGdriveSyncComponent]
})
export class GdriveLibModule { }
